import {
  MILLISECONDS_IN_DAY,
  getDayDate,
} from "src/app/utils/date.util";
import { EDalyTimeSlotLocation } from "../daly-time-slot.entity/daly-time-slot";
import { DoctorAvailability } from "../doctor-disponiblity.entity/doctor-availability";
import { EUserGender, User } from "../user.entity";

export enum EAppointmentState {
  PENDING,
  ACCEPTED,
  REJECTED,
  DONE,
}

export enum EAppointmentHistoricalState {
  EXPIRED,
  ACTUAL,
  SNOOZED,
  ALL,
  ATTENTE
}

export interface IAppointement {
  id: string;
  date: Date;
  startTime: number;
  duration: number;
  location: EDalyTimeSlotLocation;
  status: EAppointmentState;
  motif: string;
  isEmergency: boolean;
  hasPrescription: boolean;
  hasConsultation: boolean;
  regularAmount: number;
  totalAmount:number;
  paidAmount: number;
  requested: boolean;
  confirmed: boolean;
patientFirstName: string;
  patientLastName: string;
  patientMobilePhone: string | null;
  patientBirthDate: Date;
  patientMobilePhone1: string | null;
  patientRef: string;
  patientId:string;
  patientGender:EUserGender;
  patientCnamCode:string;
  requestDuration: number
  isPaid: boolean;
  colorCode:string;
  createdBy:User;

}

export class Appointment implements IAppointement {
  id: string;
  date: Date;
  startTime: number;
  duration: number;
  location: EDalyTimeSlotLocation;
  status: EAppointmentState;
  motif: string;
  createdBy:User;

  isEmergency: boolean;
  hasPrescription: boolean;
  hasConsultation: boolean;
  historicalStatus: EAppointmentHistoricalState;
  regularAmount: number;
  totalAmount:number;
  paidAmount: number;
  requested: boolean;
  confirmed: boolean;
  patientFirstName: string;
  patientLastName: string;
  patientMobilePhone: string | null;
  patientBirthDate: Date;
  patientMobilePhone1: string | null;
  patientRef: string;
  patientId:string;
  patientGender:EUserGender;
  patientCnamCode:string;
  
  requestDuration: number;
  isPaid: boolean;
  language: string;
colorCode:string;
  patientEmail: any;
  patientCountry: any;

  get startDateTime(): Date {
    return new Date(getDayDate(this.date).getTime() + this.startTime);
  }
 static calculateAge(user: Appointment, date: Date): { years: number, months: number, days: number } {

    let ageInMilliseconds = date.getTime() - user.patientBirthDate.getTime();

    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    const millisecondsPerMonth = 30.44 * millisecondsPerDay;
    const millisecondsPerYear = 365.25 * millisecondsPerDay;

    // Calculate the age in years, months, and days
    let years = Math.floor(ageInMilliseconds / millisecondsPerYear);
    let remainingMilliseconds = ageInMilliseconds % millisecondsPerYear;
    let months = Math.floor(remainingMilliseconds / millisecondsPerMonth);
    remainingMilliseconds %= millisecondsPerMonth;
    let days = Math.floor(remainingMilliseconds / millisecondsPerDay);

    return { years: years, months: months + (years * 12), days: days + (years * 360) + (months * 30) };
  }
  static calculateAgeInWeeks(user: Appointment, date: Date): { years: number; months: number; days: number; weeks: number } {
    let birthDate = user.patientBirthDate;

    let years = date.getFullYear() - birthDate.getFullYear();
    let months = date.getMonth() - birthDate.getMonth();
    let days = date.getDate() - birthDate.getDate();

    // Ajustement si le mois ou le jour est négatif
    if (days < 0) {
      months--;
      let previousMonth = new Date(date.getFullYear(), date.getMonth(), 0); // Dernier jour du mois précédent
      days += previousMonth.getDate();
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    // Calcul total en jours et conversion en semaines
    let totalDays = years * 365 + months * 30 + days;
    let weeks = Math.floor(totalDays / 7);

    return { years, months, days, weeks };
  }

  get old(): number {
    let d = new Date(this.patientBirthDate);
    let age = new Date().getFullYear() - d.getFullYear();
    var m = new Date().getMonth() - d.getMonth();
    if (m < 0 || (m === 0 && new Date().getDate() < d.getDate())) {
      age = age - 1;
    }
    return age;
  }

  get calculateAge(): { years: number, months: number, days: number } {

    let ageInMilliseconds = Date.now() - this.patientBirthDate.getTime();

    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    const millisecondsPerMonth = 30.44 * millisecondsPerDay;
    const millisecondsPerYear = 365.25 * millisecondsPerDay;

    // Calculate the age in years, months, and days
    let years = Math.floor(ageInMilliseconds / millisecondsPerYear);
    let remainingMilliseconds = ageInMilliseconds % millisecondsPerYear;
    let months = Math.floor(remainingMilliseconds / millisecondsPerMonth);
    remainingMilliseconds %= millisecondsPerMonth;
    let days = Math.floor(remainingMilliseconds / millisecondsPerDay);

    return { years: years, months: months + (years * 12), days: days + (years * 360) + (months * 30) };
  }
  get calculateAgeweeks(): { years: number, months: number, days: number, weeks: number } {
    let birthDate = this.patientBirthDate;
    let today = new Date();

    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();

    // Ajustement des valeurs si nécessaire
    if (days < 0) {
      months--;
      let previousMonth = new Date(today.getFullYear(), today.getMonth(), 0); // Dernier jour du mois précédent
      days += previousMonth.getDate();
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    // Calcul du total en jours et conversion en semaines
    let totalDays = years * 365 + months * 30 + days;
    let weeks = Math.floor(totalDays / 7);
    return { years, months, days, weeks };
  }

  get yearsOld(): number {
    let birthDate = new Date(this.patientBirthDate);
    let currentDate = new Date();
    return currentDate.getFullYear() - birthDate.getFullYear();
  }
  get doctorAvailability(): DoctorAvailability {
    return new DoctorAvailability({
      location: this.location,
      startTime: this.startTime,
      date: this.date,
      duration: this.duration,
    })
  }
  constructor(other?: Partial<Appointment>) {
    this.id = other?.id || "";
    this.date = other?.date || new Date(0);
    this.startTime = other?.startTime || 0;
    this.duration = other?.duration || 0;
    this.location = other?.location || EDalyTimeSlotLocation.ATSITE;
    this.motif = other?.motif || "";
    this.status = other?.status || EAppointmentState.PENDING;
    this.isEmergency = other?.isEmergency || false;
    this.hasConsultation = other?.hasConsultation || false;
    this.hasPrescription = other?.hasPrescription || false;
    this.historicalStatus =
      other?.historicalStatus || EAppointmentHistoricalState.EXPIRED;
    this.regularAmount = other?.regularAmount || 0;
    this.createdBy= other?.createdBy || new User();
    this.totalAmount = other?.totalAmount || 0;
    this.paidAmount = other?.paidAmount || 0;
    this.requested = other?.requested || false;
    this.confirmed = other?.confirmed || false;
    this.patientBirthDate = other?.patientBirthDate || new Date(0);
    this.patientLastName = other?.patientLastName || '';
    this.patientFirstName = other?.patientFirstName || '';
    this.patientMobilePhone = other?.patientMobilePhone ||  null;
    this.patientMobilePhone1 = other?.patientMobilePhone1 || null;
    this.patientRef = other?.patientRef || "";
    this.patientId = other?.patientId || "";
    this.patientGender = other?.patientGender || EUserGender.HOMME;
    this.patientCnamCode = other?.patientCnamCode || "";
    this.requestDuration = other?.requestDuration || 0;
    this.isPaid = other?.isPaid || false;
    this.language = other?.language || 'fr';
    this.patientEmail = other?.patientEmail || '';
    this.patientCountry = other?.patientCountry || '';
    this.colorCode = other?.colorCode || '';
  }


  get isOld(): boolean {
    return (
      this.date.getTime() + MILLISECONDS_IN_DAY - 1 <=
      new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      ).getTime()
    );
  }

  public static fromResponse(res: any): Appointment {
    
    return new Appointment({
      id: res.id,
      startTime: res.startTime,
      duration: res.duration,
      location: res.location,
      status: res.status,
      motif: res.motif?.trim(),
      date: new Date(res.date),
      isEmergency: res.isEmergency,
      hasConsultation: res.hasConsultation,
      hasPrescription: res.hasPrescription,
      historicalStatus: res.historicalStatus,
      regularAmount: res.regularAmount,
      totalAmount:res.totalAmount,
      paidAmount: res.paidAmount,
      requested: res.requested,
      confirmed: res.confirmed,
      isPaid: res.paid,
      createdBy: res.createdBy != null ? User.fromResponse(res.createdBy) : new User(),
      patientBirthDate: new Date(res.patientBirthDate),
      patientFirstName: res.patientFirstName,
      patientLastName: res.patientLastName,
      patientMobilePhone: res.patientMobilePhone,
      patientEmail: res.patientEmail,
      patientCountry: res.patientCountry,
      requestDuration: res.requestDuration,
      language: res.language,
      colorCode: res.colorCode || null, // Default color code if not provided
      patientMobilePhone1: res.patientMobilePhone1,
      patientRef: res.patientRef,
      patientId: res.patientId,
      patientGender: res.patientGender =='Feminine'?EUserGender.FEMME:EUserGender.HOMME,
      patientCnamCode: res.patientCnamCode,


    });
  }
}
